import React, { Component } from 'react'
import { List } from 'immutable'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import SelectList from 'components/common/SelectList'
import { setActiveView } from 'reducers/seaLice/reducer'
import messages from 'components/Apps/SeaLiceMonitor/translate'
import * as SLHelper from 'helpers/seaLice'

class ViewFilter extends Component {
  onViewChange = v => {
    if (v) {
      this.props.setActiveView(v.index)
    }
  }

  render() {
    const {
      activeView,
      intl: { formatMessage },
    } = this.props
    const views = SLHelper.VIEW_FILTER_LIST.map(({ id, name }) => ({
      id,
      name: formatMessage(messages[name]),
    }))

    return (
      <div className="caption-panel">
        <SelectList
          label={formatMessage(messages.view)}
          className="sealice-table-select"
          name="view"
          onChange={this.onViewChange}
          list={List(views)}
          value={activeView}
          map={{
            index: 'id',
            text: 'name',
          }}
        />
      </div>
    )
  }
}

export default connect(
  state => ({
    activeView: state.getIn(['seaLice', 'activeView']),
  }),
  {
    setActiveView,
  },
)(injectIntl(ViewFilter))
